import { defineStore } from "pinia";
import { ref } from "vue";

export interface ToastConfig {
  open: boolean;
  appearance: "success" | "error" | "warning" | "info";
  bodyKey: string;
  duration?: number;
}

export const useUiStore = defineStore("ui", () => {
  const loading = ref(false);
  const toast = ref<ToastConfig | null>(null);

  const showToast = (appearance: ToastConfig["appearance"], bodyKey: string, duration = 4000) => {
    toast.value = { open: true, appearance, bodyKey, duration };
  };

  const clearToast = () => {
    toast.value = null;
  };

  return {
    loading,
    toast,
    showToast,
    clearToast
  };
});
